import { environment as env } from './shared_env';

export const environment = {
    ...env,
    production: false,
    envAbbr: 'sb',
    version: Date.now().toString(), // Timestamp-based cache busting for test
    backendApiUrl: 'https://exx-test-backend-5avfaz2cyq-uc.a.run.app',
    clientUrl: 'https://venus.exxactcorp.com',
};
